/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateNativeAidRequest
 */
export interface CreateNativeAidRequest {
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CreateNativeAidRequest
     */
    aid: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CreateNativeAidRequest
     */
    alias?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateNativeAidRequest
     */
    oobi: Array<string>;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof CreateNativeAidRequest
     */
    orgId?: string;
    /**
     * Type of the AID
     * @type {string}
     * @memberof CreateNativeAidRequest
     */
    type: string;
    /**
     * Does AID relate to multisig or singlesig?
     * @type {boolean}
     * @memberof CreateNativeAidRequest
     */
    isMultisig?: boolean;
    /**
     * Number of users required for signing. Used for multisigs only
     * @type {string}
     * @memberof CreateNativeAidRequest
     */
    signingThreshold?: string;
    /**
     * User Id
     * @type {string}
     * @memberof CreateNativeAidRequest
     */
    userId?: string;
}

/**
 * Check if a given object implements the CreateNativeAidRequest interface.
 */
export function instanceOfCreateNativeAidRequest(value: object): boolean {
    if (!('aid' in value)) return false;
    if (!('oobi' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function CreateNativeAidRequestFromJSON(json: any): CreateNativeAidRequest {
    return CreateNativeAidRequestFromJSONTyped(json, false);
}

export function CreateNativeAidRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNativeAidRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'aid': json['aid'],
        'alias': json['alias'] == null ? undefined : json['alias'],
        'oobi': json['oobi'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'type': json['type'],
        'isMultisig': json['isMultisig'] == null ? undefined : json['isMultisig'],
        'signingThreshold': json['signingThreshold'] == null ? undefined : json['signingThreshold'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function CreateNativeAidRequestToJSON(value?: CreateNativeAidRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'aid': value['aid'],
        'alias': value['alias'],
        'oobi': value['oobi'],
        'orgId': value['orgId'],
        'type': value['type'],
        'isMultisig': value['isMultisig'],
        'signingThreshold': value['signingThreshold'],
        'userId': value['userId'],
    };
}

